<template>
<div>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</div>

</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
